import { gql } from 'apollo-boost';

export const GET_CANDIDATE_DUPLICATION_TEMPLATES = gql`
  query getCandidatePageDuplicationTemplates($organizationRevvUid: String) {
    viewer {
      candidate(revvUid: $organizationRevvUid) {
        page_duplication_templates {
          id
          name
          slug
          revv_uid
          recurring_agency_fees_enabled
          upsell_agency_fees_enabled
          source_code
          partnership_templates {
            id
            name
            feePercentage
            partnershipId
            avatar {
              id
              image {
                thumbnailUrl
              }
            }
          }
        }
      }
    }
  }
`;

export const CREATE_CANDIDATE_DUPLICATION_TEMPLATE = gql`
  mutation createCandidateTemplateMutation(
    $template: BasePageDuplicationTemplateInputType!
    $organizationRevvUid: String!
  ) {
    candidateCreatePageDuplicationTemplate(template: $template, organizationRevvUid: $organizationRevvUid) {
      errors
      pageDuplicationTemplate {
        created_at
        deleted_at
        id
        name
        recurring_agency_fees_enabled
        slug
        updated_at
        upsell_agency_fees_enabled
        revv_uid
        source_code
        partnership_templates {
          id
          feePercentage
          partnershipId
          avatar {
            id
            image {
              thumbnailUrl
            }
          }
        }
      }
      dammed
    }
  }
`;
export const UPDATE_CANDIDATE_DUPLICATION_TEMPLATE = gql`
  mutation UpdateCandidateTemplateMutation(
    $template: UpdatePageDuplicationTemplateInputType!
    $organizationRevvUid: String!
  ) {
    candidateUpdatePageDuplicationTemplate(template: $template, organizationRevvUid: $organizationRevvUid) {
      errors
      pageDuplicationTemplate {
        created_at
        deleted_at
        id
        name
        recurring_agency_fees_enabled
        slug
        updated_at
        upsell_agency_fees_enabled
        revv_uid
        source_code
        partnership_templates {
          id
          feePercentage
          partnershipId
          avatar {
            id
            image {
              thumbnailUrl
            }
          }
        }
      }
      dammed
    }
  }
`;

export const DELETE_CANDIDATE_DUPLICATION_TEMPLATE = gql`
  mutation DeleteTemplateMutation($revvUid: String!, $organizationRevvUid: String!) {
    candidateDeletePageDuplicationTemplate(organizationRevvUid: $organizationRevvUid, revvUid: $revvUid) {
      errors
      message
    }
  }
`;
